import { ACTION } from './constants';
import request from '../../../../utils/request';
import {hideMainLoader, showMainLoader} from '../../../actions';
import {requestConfig} from "../../../../config/apiResource";

export function getCategory() {
        return dispatch => {
            return request(requestConfig.getCategory())
                .then((json) => {
                    json && dispatch({ type: ACTION.GET_CATEGORY , data: json.data });
                }).catch((error) => {
                    console.log("Got Error with category api: " + error)
                });
        }
}

export function getSubjects(categoryType) {
        return dispatch => {
            return request(requestConfig.getSubjects(categoryType))
                .then((json) => {
                    json && dispatch({ type: ACTION.GET_SUBJECT , data: json.data });
                }).catch((error) => {
                    console.log("Got Error with  subject api: " + error)
                });
        }
    }


export function clearGetSubjects() {
    return   dispatch => {dispatch({ type: ACTION.CLEAR_SUBJECT });}
}

export function sendOtp(formData) {
        return dispatch => {
                return request(requestConfig.sendOtps(formData))
                    .then((json) => {
                            json && dispatch({ type: ACTION.SEND_OTP , data: json.data });
                    }).catch((error) => {
                            console.log("Got Error with send otp: " + error)
                    });
        }
}
export const getCsrfToken = () => {
        return dispatch => {
            dispatch(showMainLoader());
            return request(requestConfig.getCsrfTokenService())
                .then((json) => {
                    dispatch(hideMainLoader());
                    json && dispatch({ type: 'GET_WRITE_TO_TOKEN' , data: json.data });
                    return json;
                }).catch((error) => {
                    dispatch(hideMainLoader());
                    console.log("Got Error with WhatsApp Service content " + error)
                });
        }
}
export function postWriteUsSubmit(formData) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.postWriteUsSubmit(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.POST_WRITE_US , data: json.data });
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with write us post: " + error)
            });
    }
}
    

